import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-session-replaced-modal',
  templateUrl: './session-replaced-modal.component.html',
  styleUrls: ['./session-replaced-modal.component.scss'],
})
export class SessionReplacedModalComponent {
  constructor(
    private readonly dialogRef: NbDialogRef<SessionReplacedModalComponent>,
    private readonly router: Router
  ) {}

  signIn(): void {
    this.cancel();
    this.router.navigate(['/account/login']);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
